// @ts-check
import { DEFAULT_LANGUAGE } from '@erpagroapp/common';
import { defineConfig } from '../utils';

export function app() {
  return defineConfig({
    properties: {
      'App.Idioma': {
        /** @type {typeof import('@erpagroapp/common').LANGUAGES[number]} */
        defaultValue: DEFAULT_LANGUAGE,
      },
      'App.URLWebService': {
        /** @type {string | null} */
        defaultValue: null,
      },
      'App.Logo': {
        /** @type {string | null} */
        defaultValue: null,
      },
      'App.PermitirLoginNFC': {
        defaultValue: true,
      },
    },
  });
}
